//#region src/modules/Scheduling/shared/ShiftProgressBar/utils/getProgressBarBackground.ts
var getProgressBarBackground = (elapsedTimePercent, color, backgroundColor = "var(--color-surface-subtle)") => `
    ${backgroundColor} 
    linear-gradient(
      to right,
      ${color ? `${color}66` : "var(--color-neutral-faded)"} calc(${elapsedTimePercent} - 2px),
      ${color || "var(--color-neutral)"} calc(${elapsedTimePercent} - 2px) ${elapsedTimePercent},
      transparent ${elapsedTimePercent}`;
//#endregion
export { getProgressBarBackground };

//# sourceMappingURL=getProgressBarBackground.js.map